import { render, staticRenderFns } from "./LoadAmountList.vue?vue&type=template&id=39a46f44&scoped=true&"
import script from "./LoadAmountList.vue?vue&type=script&lang=js&"
export * from "./LoadAmountList.vue?vue&type=script&lang=js&"
import style0 from "./LoadAmountList.vue?vue&type=style&index=0&id=39a46f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a46f44",
  null
  
)

export default component.exports